<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import message from "../../utils/message";
    import request from "@/utils/axios.js";
    import {reBase} from "../../utils/url"

    export default {
        name: "Product",
        components: {CommonTable},
        data(){
            return {
                searchs:[

                ],
                permission:{
                    add: 'product:add',
                    update: 'product:update',
                    delete: 'product:delete',
                    deleteBatch: 'product:deleteBatch'
                },
                url: {
                    get: '/product/listByCondition',
                    add: '/product/add',
                    update: '/product/update',
                    delete: '/product/delete/',
                    delete_batch: '/product/deleteBatch',
                    //status: '/siteInfo/status',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                },{
                    field: 'productName',
                    label: '商品名称',
                    show: true,
                    width: '',
                }, {
                    field: 'imgUrl',
                    label: '商品图片',
                    show: true,
                    width: '',
                }, {
                    field: 'minPrice',
                    label: '最低价格',
                    show: true,
                    width: '',
                }, {
                    field: 'maxPrice',
                    label: '最高价格',
                    show: true,
                    width: '',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                operate: [{
                    icon: 'el-icon-upload2',
                    type: 'text',
                    text: '上传图片',
                    uploadImg: true,
                    url: this.reUrl + '/system/upload/img',
                    // 用于存储handle的row
                    value: {},
                    handle: (row) => {
                        this.value = row;
                    },
                    success: (res) => {
                        if (res.code === 0) {
                            const value = JSON.parse(JSON.stringify(this.value));
                            value.imgUrl = reBase + res.data;
                            request.post({
                                url: '/product/update',
                                data: this.value,
                                success: (data) => {
                                    if (data.code === 0){
                                        message.success("商品图片上传成功");
                                        this.value.imgUrl = reBase + res.data;
                                    }else {
                                        message.error("商品图片上传失败");
                                    }
                                }
                            });
                        } else if (res.code === 102) {
                            window.localStorage.removeItem('username');
                            window.localStorage.removeItem('sessionId');
                            window.parent.location.href = this.feUrl + '/login.html';
                        }
                    }
                }],
                formFields: {
                    addTitle: '添加商品',
                    updateTitle: '修改商品',
                    model: [{
                        field: 'productName',
                        label: '商品名称：',
                        type: 'input',
                        placeholder: '商品名称',
                        rules:[{message: '请输入商品名称', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'imgUrl',
                        label: '商品图片地址：',
                        type: 'input',
                        placeholder: '商品图片地址',
                        rules:[{message: '请输入商品图片地址', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'minPrice',
                        label: '最低价格：',
                        type: 'input',
                        placeholder: '最低价格',
                        rules:[{message: '请输入最低价格', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }, {
                        field: 'maxPrice',
                        label: '最高价格：',
                        type: 'input',
                        placeholder: '最高价格',
                        rules:[{message: '请输入最高价格', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }],
                }
            }
        }
    }
</script>

<style scoped>

</style>
